"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedBar = void 0;
class FixedBar {
    static init() {
        const bar = document.querySelector('.fixed-bar');
        const content = document.querySelector('.fixed-bar-target');
        if (bar == undefined || content == undefined) {
            return;
        }
        const offset = content.offsetTop;
        document.addEventListener('scroll', () => {
            if (window.scrollY > offset) {
                bar.classList.add('visible');
            }
            else {
                bar.classList.remove('visible');
            }
        });
    }
}
exports.FixedBar = FixedBar;
